import * as React from 'react'

import classNames from 'classnames/bind'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  className?: string
  withBackground?: boolean
  onSubmit?: () => Promise<any> | void
}

const Form: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  withBackground,
  onSubmit,
  children,
}) => {
  const [submitting, setSubmitting] = React.useState(false)
  const mountedRef = React.useRef(true)

  React.useEffect(() => {
    mountedRef.current = true
    return () => {
      mountedRef.current = false
    }
  }, [])

  const handleSubmit = React.useCallback<React.FormEventHandler<HTMLFormElement>>(
    (event) => {
      event.preventDefault()

      if (submitting || !onSubmit) {
        return false
      }

      const result = onSubmit()

      if (!result) return

      setSubmitting(true)
      result
        .then(() => {
          if (mountedRef.current) {
            setSubmitting(false)
          }
        })
        // FIXME: Do something with this error
        // eslint-disable-next-line no-console
        .catch((err) => console.error(err))
    },
    [submitting, onSubmit]
  )

  return (
    <form
      className={cx('form', className, {
        withBackground,
      })}
      onSubmit={handleSubmit}
    >
      {children}
    </form>
  )
}

export default Form
